// Profile of Adrian Eisenmeier, Swedish. Source of the profile page.
module.exports = {
  headline: 'Diplomfysiker • AI-expert • Mjukvaruutvecklare',
  summary: 'Adrian Eisenmeier utvecklar system och ger råd där AI, mjukvaruarkitektur, dataskydd och säkerhet möts i praktiken: Intent-Driven Development för AI-stödd mjukvaruutveckling, lokal anonymisering av personuppgifter, finansanalys och praktiknära utbildning.',
  imageAlt: 'Porträtt av Adrian Eisenmeier',
  personal: {
    position: 'Grundare och verkställande direktör för pAIoneer Labs GmbH',
    birthdate: '13 juni 1985',
    nationality: 'Tysk',
    maritalStatus: 'Ogift',
    languages: 'Tyska (modersmål), engelska (flytande), nederländska (grundläggande kunskaper)',
    programmingLanguages: 'Python (16 år), R (17 år), C# (9 år), C/C++ (11 år), JavaScript fullstack (React, TypeScript) (5 år)'
  },
  education: [
    {
      period: '2007 - 2016',
      field: 'Studier: fysik, meteorologi',
      institution: 'Albert-Ludwigs-Universität Freiburg, Tyskland',
      degree: 'Examen: diplom i fysik'
    }
  ],
  skills: [
    {
      title: 'Agentisk AI & LLM-engineering',
      description: 'Agentiska AI-system, Intent-Driven Development (IDD), arbetsflöden med OpenCode och Claude Code, agentinstruktioner och skills, Model Context Protocol (MCP) med Python, TypeScript, PHP och C#, lokala LLM-stackar med vLLM, Ollama och Hugging Face, arkitekturer för RAG, GraphRAG och Agentic RAG, RAG-utvärderingar, Explainable AI, prompt engineering, modellkvantisering och finjustering med PEFT/LoRA'
    },
    {
      title: 'Data science, maskininlärning & signalanalys',
      description: 'Scikit-Learn, H2O, TensorFlow-Keras, PyTorch, SciPy, ML.NET, Random Forest, LSTM, neurala nätverk, Boltzmann-, Hopfield- och Jordan-nätverk, datorseende och bildbehandling med OpenCV, SkiaSharp och Pillow, SIFT, SURF, ORB, Laplace- och Fouriertransformer, signal-brusanalys, tidsserieanalys, prognoser, ARIMA och pyramid Auto-ARIMA, NLP, analys av servicesamtal, KPI-aggregering, prediktiva modeller, FAME-migrering, Chou Combination Index samt maskininlärning för medicinteknik och farmaci'
    },
    {
      title: 'Mjukvaruutveckling, ramverk & UI',
      description: 'Python, R, C#, C++, C, JavaScript, TypeScript, React, Java, Android, Lua, Bash, PHP, MATLAB, Mathematica, .NET 6/8, C++20, C++/CLI, BeeWare, Toga UI, Xamarin Forms, MAUI, HTML5, CSS, användargränssnitt för desktop, mobil och webb, mjukvaruarkitektur, backend- och fullstackarkitektur, händelsedriven arkitektur och digitala tvillingar'
    },
    {
      title: 'API-design, tjänster & integration',
      description: 'ASP.NET/ASP, FastAPI, Flask API, Plumber, REST-API:er, gRPC, Swagger/OpenAPI, API-design, tjänstekontrakt, mikrotjänstnära REST-arkitekturer, gRPC-tjänster i C# med reflection, backends med Python och FastAPI, API-integrationer mot Taiga, Jira och Azure DevOps, tjänsteintegrationer för robotik och IoT samt autentiserings- och backendintegration'
    },
    {
      title: 'Databaser, ORM & persistens',
      description: 'SQL, SQL Server, SQLite, MySQL, Azure SQL, Azure Cosmos DB, Entity Framework och Entity Framework Core som ORM-lager, SQL-databaser för anonymisering samt för tidsserie-, tick-, marknads-, väder- och energidata, vektordatabaser med ChromaDB och Qdrant, RAG-dokumentindex, datakvalitetskontroller och validering av rapportering'
    },
    {
      title: 'Moln, DevOps & infrastruktur',
      description: 'Administration av Linux- och Windows-servrar, GPU- och edge-AI-infrastruktur, Docker, Docker Compose, Podman, Kubernetes, containertjänster, lokala LLM-stackar on-premises, Azure Functions, IoT Hub, Event Hub, Digital Twins, Key Vault och Time Series Insights, AWS EC2, ECS, S3 och Lambda, Azure DevOps, GitLab-pipelines, GitLab-runners och -executors, Caddy, Nginx, Let\'s Encrypt, lokala testmiljöer och containerorkestrering på sensorhårdvara'
    },
    {
      title: 'Dashboards, rapportering & övervakning',
      description: 'R Shiny, Python Shiny, ShinyProxy, Grafana, Kibana, CheckMK-dashboards, Zabbix, RMarkdown, Shiny-dashboards för logganalys, övervakning med Kibana, KPI- och processvisualisering, controllingsystem, statistiska rapporter, daglig validering av rapportering och operativa övervakningsvyer'
    },
    {
      title: 'Säkerhet, dataskydd & CRA',
      description: 'Expert på Cyber Resilience Act (CRA), CRA-beredskap, secure by design och security by default, SBOM och säkerhet i mjukvarans leveranskedja, hotmodellering, sårbarhetshantering, penetrationstester och IT-säkerhet (Kali, Tails Linux, Metasploit Framework, Nmap), IoT/OT-säkerhet, Bluetooth Low Energy, Bluetooth Mesh, MQTT, Mosquitto, Presidio, PII och dataskydd'
    },
    {
      title: 'Projektmetodik & AI-transformation',
      description: 'Lean AI, utvärdering av användningsfall, ROI/TCO-beräkning, processklassificering, införande av Intent-Driven Development, avgränsning mellan IDD och Spec-Driven Development, professionell ersättning för vibe coding, agil utveckling, testdriven utveckling, Scrum, Redmine, Jira, Taiga, Mantis, kravhantering, kommunikation med intressenter, releasekommunikation samt dokumentation med Confluence och Doxygen'
    }
  ],
  positions: [
    {
      period: 'januari 2026 - idag',
      title: 'AI-ingenjör, mjukvaruarkitekt, konsult inom försvarsindustrin',
      technologies: 'CUDA, vLLM, Ollama, Hugging Face, MCP Python, MCP TypeScript, MCP PHP, CI/CD GitLab-pipelines, Docker, vektordatabaser (ChromaDB, Qdrant), RAG- / GraphRAG- / Agentic RAG-arkitekturer, RAG-utvärderingar, Explainable AI, Intent-Driven Development, Lean AI, OpenCode, Claude Code',
      description: [
        'Rådgivande roll vid framtagande och planering av en företagsövergripande AI-strategi. Utvärdering och definition av AI-användningsfall enligt Lean AI-processer för projektledning.',
        'Beräkning av avkastning på investeringen (return on investment) samt klassificering av AI-användningsfall efter processtyp och lönsamhet.',
        'Agentisk mjukvaruutveckling och edge computing: planering och införande av lokala alternativ till Anthropic för att ge utvecklingsteam en OpenCode-miljö on-premises som motsvarar Claude Code, särskilt för AI-användningsfall med data som är klassificerade som VS-NfD (sekretessbelagd information - endast för tjänstebruk).',
        'Migrering av agentinstruktioner och skill sets från Claude Code till agentinstruktioner och skills i OpenCode.',
        'Planering av hårdvara och anskaffningskostnader för krav där utvecklingsteam på 30 personer parallellt utvecklar agentiskt enligt IDD med en time to first token (TTFT) under 10 sekunder, med lokala LLM:er som i SWE-benchmarks kommer nära Claude Code.',
        'Efter avslutad planering konkret implementering av agentiska, multimodala AI-användningsfall.',
        'Utbildning av mjukvaruutvecklare i Intent-Driven Development (IDD), avgränsning mot Spec-Driven Development samt workshoppar om fördelarna med IDD.',
        'Etablering av strukturerade utvecklingsprocesser för AI-stödd mjukvaruutveckling som professionell ersättning för okontrollerad vibe coding.'
      ]
    },
    {
      period: 'december 2025 - april 2026',
      title: 'Mjukvaruutvecklare, banksektorn',
      technologies: 'R Shiny',
      description: [
        'Implementering av en R Shiny-dashboard för visualisering och utvärdering av globala banksimuleringar (GBS).'
      ]
    },
    {
      period: 'september 2025 - december 2025',
      title: 'Mjukvaruutvecklare / AI-ingenjör, Kassenzahnärztliche Vereinigung Baden-Württemberg (KZV BW)',
      technologies: 'Python, Microsoft Presidio SDK, NLP-modeller från spaCy, FastAPI, Beeware, Docker, SQL, dataskydd / personuppgifter (PII)',
      description: [
        'Design och implementering av ett generiskt PII-programvarusystem som stöder alla världens språk för att identifiera, anonymisera och avanonymisera personliga och konfidentiella uppgifter i Office-dokument.',
        'Användning av NLP-modeller från spaCy och Microsoft Presidio Data Protection and De-identification SDK. En SQL-databas lagrar datapar av klartext och anonymisering. Levererat som dockeriserat FastAPI med Swagger-dokumentation, som fristående Python-bibliotek samt som fristående program för Windows och macOS med Beeware och nativt Toga-gränssnitt.'
      ]
    },
    {
      period: 'augusti 2025 - december 2025',
      title: 'Mjukvaruutvecklare / AI-ingenjör, industriell IoT',
      technologies: 'Python, Docker, Podman, FastAPI, OpenCV, Shiny, Kibana, HTML, CSS, Lua, inbyggda system',
      description: [
        'Senior mjukvaruutvecklare för vidareutvecklingen av en smart stereoskopisk kamera med AI-hårdvara baserad på Hailo-processorer.',
        'Objektdetektering och utvärdering i realtid i Python och Lua. Utveckling av ett API för containerorkestrering direkt på sensorhårdvaran. Shiny-dashboard för logganalys och övervakning med Kibana, containeriserade och driftsatta på sensorelektroniken. Webbapplikation som körs på kameran, byggd med HTML, CSS och JavaScript.'
      ]
    },
    {
      period: 'januari 2025 - idag',
      title: 'Mjukvaruutvecklare / AI-ingenjör, KRIKO Engineering GmbH',
      technologies: 'C#, gRPC, Simatic PCS7, SQL, JavaScript, React, Docker, Python, FastAPI, Swagger, PyTorch, CUDA, RAG, GRAG, agenter, Hugging Face, R Shiny, GitLab, GitLab-runners och -executors, Azure DevOps, Taiga- och Jira-API',
      description: [
        'Senior mjukvaruarkitekt för multifunktionella agentiska AI-system och DevOps-automatisering. Utveckling av gRPC-tjänster i C# med reflection och av autonoma AI-agenter för röststyrd kodbearbetning i Azure DevOps och GitLab.',
        'Planering och utveckling av backendarkitekturer med Python och FastAPI samt frontend i React och TypeScript. Fullständigt dockeriserad driftsättning av alla systemkomponenter. Implementering av RAG/GRAG-pipelines för intelligent analys av kodbaser och integration av interna dokument, handböcker och utbildningsmaterial.',
        'CI/CD-automatisering med AI-styrda GitLab-runners och -executors, integration med Taiga och Jira samt Model Context Protocol (MCP) för kommunikation mellan flera agenter. Kvalitetssäkring med Explainable AI, Arize Phoenix, RAG-utvärdering och hallucinationsdetektering samt övervakning och logganalys med R Shiny.'
      ]
    },
    {
      period: 'mars 2025',
      title: 'Utbildare, Kassenzahnärztliche Vereinigung Baden-Württemberg (KZV BW)',
      technologies: 'Python, PyTorch, CUDA, Docker, JupyterLab, Google Colab, Hugging Face',
      description: [
        'Teoretiska och praktiska workshoppar om generativ AI för projekt- och teamledare. Översikt över AI-landskapet, utvärderingskriterier, optimala användningsfall, klassisk maskininlärning, tidsserieanalys, signalbehandling och LLM-baserade lösningar.',
        'Skräddarsydda edge-AI-system med RAG/GRAG-arkitekturer och finjustering med LoRA/QLoRA, autonoma AI-agenter, chattbotlösningar, hostingstrategier, investeringsanalys, total ägandekostnad (total cost of ownership), dataanonymisering och efterlevnad av EU AI Act.'
      ]
    },
    {
      period: 'juli 2024 - augusti 2024',
      title: 'Mjukvaruutvecklare, IoT',
      technologies: 'Azure IoT, Digital Twins, Event Hubs, SQL-databas, Azure Functions, C# (.NET 8), REST-API:er, gRPC, Docker',
      description: [
        'Utveckling av en digital tvilling för vattenfilter, en lokal testmiljö med Docker och integration i Azure-molnet.'
      ]
    },
    {
      period: 'juli 2024',
      title: 'Utbildare, förlagsbranschen',
      technologies: 'Python, PyTorch, CUDA, Docker, JupyterLab, Google Colab, Hugging Face',
      description: [
        'Teoretiska och praktiska workshoppar om generativ AI för projekt- och teamledare med fokus på val av användningsfall, edge-AI, RAG/GRAG, agenter, chattbotar, hostingstrategier, dataskydd, EU AI Act och säkerhetskoncept.'
      ]
    },
    {
      period: 'oktober 2023 - oktober 2025',
      title: 'Forskning och utveckling, AI och robotik, Hochschule Offenburg',
      technologies: 'Python, PyTorch, LLM:er, ChatGPT, RESTGPT, NanoGPT, Java, Android, REST-API, Swagger, C#/C++, MS Azure, Azure DevOps Pipelines, HTML, CSS, JavaScript, Python Shiny',
      description: [
        'Utveckling av AI-metoder för digitala assistenter samt för igenkänning och klassificering av känslor utifrån bild- och ljuddata. Dockeriserade prototyper med olika GPT-modeller, API-implementeringar samt träning av lokala alternativa LLM:er baserade på öppna modeller med webbdata och användarspecifika data. Övervakning med Shiny-dashboards.',
        'Styrning av ett telenärvarorobotsystem och koppling av roboten till serverapplikationer via REST-API:er.'
      ],
      pageBreakBefore: true
    },
    {
      period: 'augusti 2022 - mars 2024',
      title: 'Teknisk ledare, Scrum Master, internationell banksektor, T-Systems',
      technologies: 'FAME, Python, R, RMarkdown, Camunda, Docker, Kubernetes, GitLab, Confluence, Jira, R Shiny',
      description: [
        'Ledning av ett team av mjukvaruutvecklare och data scientists i ett omfattande migreringsprojekt inom den internationella banksektorn.',
        'Förberedelse och ledning av teammöten, retrospektiv, Scrum of Scrums, release reviews och kundpresentationer. Samordning med kravhantering, produktägare och teamledare.',
        'Utveckling av ett R-bibliotek för standardiserade statistiska rapporter genom nyimplementering av befintlig FAME-logik i R och Python. Camunda-executors i Python, konfiguration av arbetsflöden, GitLab-pipelines och automatiserad Confluence-dokumentation.'
      ]
    },
    {
      period: 'maj 2021 - juli 2022',
      title: 'Mjukvaruutvecklare, mjukvaruarkitekt, ERGO Group AG',
      technologies: 'C#, C++, Matlab',
      description: [
        'Nyimplementering i C# av en Matlab-programvara för värdering och förvaltning av finansiella produkter. Marknadsvärden och kassaflöden för obligationer, hypotekslån, swappar, swaptioner, inlösenbara obligationer, floaters och steepeners. Arkitektur, Entity Framework, SQLite/SQL Server, CI/CD med Azure DevOps, Doxygen, C++/CLI, .NET 6, C++20 samt enhets- och integrationstester.'
      ]
    },
    {
      period: 'maj 2019 - april 2021',
      title: 'Projektledare, data scientist, mjukvaruutvecklare, tryckeriindustrin (B2B)',
      technologies: 'Xamarin Forms, Entity Framework Core, OpenCV, SkiaSharp, Pillow, Docker, Flask API, MS Azure DevOps',
      description: [
        'Ledande roll i utvecklingen av en applikation för upptäckt av förfalskningar och robust fingeravtrycksberäkning för patenterade säkerhetsetiketter. Bildbehandling med SIFT, SURF, ORB, Laplace- och Fouriertransformer, signal-brusanalyser, CI-driftsättning för Android och iOS, REST-API-integration, heartbeat-tjänst och svarssystem.'
      ]
    },
    {
      period: 'februari 2020 - juni 2020',
      title: 'Data scientist, energiteknik (B2C)',
      technologies: 'Azure TSI, Azure Cosmos DB, Azure SQL Database, Azure Functions, Azure Key Vault, pyramid ARIMA, Scikit-Learn, TensorFlow-Keras, Confluence, Jira',
      description: [
        'Prognoser för framtida energiförbrukning utifrån historiska data och väderprognoser. Utvärdering av ARIMA, Random Forest och LSTM med prestanda- och kvalitetsmått, tidsseriebearbetning i Azure, driftsättning i Azure Functions, daglig validering av rapporteringen och dokumentation i Confluence.'
      ]
    },
    {
      period: 'september 2019 - januari 2020',
      title: 'Projektledare, data scientist, mjukvaruutvecklare, e-handel (B2B)',
      technologies: 'Docker, MySQL, .NET Core, Swagger, R Shiny-dashboard, ShinyProxy, Caddy',
      description: [
        'Utformning och utarbetande av ett säkerhets- och autentiseringskoncept för en analysplattform inom näthandeln. Implementering som Docker-baserad REST-arkitektur.'
      ]
    },
    {
      period: 'maj 2018 - juni 2019',
      title: 'Data scientist, mjukvaruutvecklare, telekommunikation (B2C)',
      technologies: 'KNIME, Impala Hadoop, Docker, R Shiny, ShinyProxy, Random Forests med Scikit-Learn, neurala nätverk med TensorFlow',
      description: [
        'Processanalys tillsammans med verksamhetsenheterna, sökning efter rådata i Hadoop via Impala och KNIME, R-logik för KPI-aggregering, Shiny-dashboards, NLP-analys av servicesamtal, prediktiva modeller för fältservice samt ML-implementering i produktion med CI och Docker.'
      ]
    },
    {
      period: 'april 2017 - maj 2018',
      title: 'Mjukvaruutvecklare, industri och IoT (B2C)',
      technologies: 'Xamarin Forms, .NET, Bluetooth Low Energy',
      description: [
        'Utveckling av en mobilapp och en PC-programvara för programmering och styrning av kopplingsur. Bluetooth-stack, UDP-discovery-tjänst, utrullningsverktyg och underhållsprocess med ett team på tre personer.'
      ]
    },
    {
      period: '2015 - 2017',
      title: 'Systemadministratör, IT-gruppen vid Fysikaliska institutet, Albert-Ludwigs-Universität Freiburg',
      description: [
        'Uppsättning och underhåll av Windows- och Linux-avbildningar med ESXi och Xen. DHCP, CUPS, FOG-server, LDAP-autentisering, KISS-system och UPS-konfigurationer.',
        'Automatiserat system för penetrationstester av institutets nätverk med NMAP Script Engine, Metasploit-plugin baserat på CVE-poster samt IDS med Snort.'
      ]
    },
    {
      period: '2016',
      title: 'Vetenskaplig medarbetare, Fysikaliska institutet, Albert-Ludwigs-Universität Freiburg',
      technologies: 'C++, CUDA, Python, R',
      description: [
        'Utveckling och analys av igenkänningsgraden hos neurala nätverk för mönstermatchning, däribland Boltzmann-nätverk, LSTM-nätverk samt Hopfield- och Jordan-nätverk med olika inlärningsregler, aktiveringsfunktioner och kodningar, samt tränade nätverk för baslinjekorrigering i NMS- och ESR-spektra.'
      ]
    },
    {
      period: '2012 - 2015',
      title: 'Vetenskaplig medarbetare, Institutet för fysikalisk kemi, Albert-Ludwigs-Universität Freiburg',
      technologies: 'MATLAB, TurboMol, ORCA, Gromacs MD',
      description: [
        'QM/MM-simuleringar av ESR- och NMR-parametrar för flavoproteiner, CHARMM-kraftfält, energiminimering, ligninpotential och koppling av termiska ensembler till simuleringsboxen.'
      ]
    },
    {
      period: '2011 - 2012',
      title: 'Vetenskaplig medarbetare, optik / medicinteknik och farmaci',
      technologies: 'Mathematica, Python, R, KNIME',
      description: [
        'Programvara för bestämning av astigmatism och dioptrivärden hos ögonlinser med maskininlärning, inklusive implementering av patentet EP 2814916. Dessutom analys av synergieffekter vid kombinationer av cancerläkemedel och implementering av Chou Combination Index i R som KNIME-nod.'
      ]
    },
    {
      period: '2010 - 2012',
      title: 'Finansmatematik',
      technologies: 'C++, Python, R, Bash-skript',
      description: [
        'Program för hämtning av tickdata för WKN-nummer och bitcoinkurser, swingtradingstrategier för bitcoin, DAX, Dow Jones och STOXX 50 samt beräkning av glidande medelvärden.'
      ]
    }
  ]
};
